export default "__VITE_ASSET__TrhIVay1__"